// noinspection JSUnusedGlobalSymbols

export const designDocs =
  [
    {
      "name": "filters",
      "docId": "app_0_0_1",
      "designDoc": {
        "app_0_0_1": {
          filters: {
            noDeleted: function (doc) {
              return (doc._deleted !== true);
            },
            feed: (doc, req) => {
              let found = false;
              if ('type' in doc) {
                if (req.query.docs) {
                  if (req.query.docs.indexOf(doc.type) > -1) {
                    found = true;
                  }
                }
              }
              return (found === true);
            }
          }
        }
      }
    }
  ];
